<mat-dialog-content class="position-relative">
    <div class="representative-display">
        <p class="representative-display-text">{{ 'Gate.RepresentativeBarcode' | translate }}:</p>
        <p class="representative-display-barcode">
            @if (state.representativeShareholder(); as rep) {
                <span>{{ rep.shareholderId }}</span>
                <span>-</span>
                <span>{{ rep.displayName }}</span>
                <span>({{ rep.votes }})</span>
            } @else {
                <mat-spinner [diameter]="32" class="mx-auto" />
            }
        </p>
    </div>
    <form (submit)="addProxy(proxyBarcode)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-label>{{ 'Gate.ProxyBarcode' | translate }}</mat-label>
            <input #barcodeInput matInput name="proxyBarcode" [(ngModel)]="proxyBarcode" autocomplete="off" />
            @if (hasMediaDevices && !isLoading()) {
                <button type="button" mat-icon-button matSuffix (click)="openBarcodeScanDialog(addProxy)">
                    <mat-icon>qr_code_scanner</mat-icon>
                </button>
            }
            @if (isLoading()) {
                <mat-spinner matSuffix [diameter]="24" />
            }
        </mat-form-field>
    </form>

    <!-- added proxies list -->
    @if (!!state.representativeShareholder()) {
        <div class="proxies-list">
            @for (proxy of state.proxies(); track proxy.shareholderId) {
                <div class="proxy-entry">
                    <button type="button" mat-icon-button color="warn" (click)="removeProxy(proxy.shareholderId)">
                        <mat-icon>close</mat-icon>
                    </button>
                    <div>{{ proxy.shareholderId }} - {{ proxy.displayName }} ({{ proxy.votes }})</div>
                </div>
            }
        </div>
    }
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
    <button mat-button [disabled]="!state.proxies().length" (click)="submit()">{{ 'General.Save' | translate }}</button>
</mat-dialog-actions>
